import { LabelAndValue } from "../../../components/create/types/LabelAndValue";

export type CohortDataset = 'HES' | 'OPCRD';

export interface Query {
    id: number;
    active: boolean | true;
    createdOn?: number;
    updatedOn?: number;
    title: string;
    dataset: CohortDataset;
    period: Period;
    groups: Group[];
    sparkQuery?: SparkQuery;
    trackable: boolean;
    pathwayStatus: 'NONE' | 'WAITING' | 'RUNNING' | 'COMPLETE' | 'FAILED';
    stale?: boolean
    unread?: boolean
}

export interface Group {
    id: string;
    title: string;
    criteria: Criterion[];
    operator: string[];
    index: boolean;
}

export enum AdmissionMethod {
    ALL = "all",
    ELECTIVE = "elective",
    NON_ELECTIVE = "non elective"
}


export type Criterion = {
    id: string;
    description: string | undefined;
    operator: string[];
    [key: string]: any;
}

export type CriterionPcadValues = {
    dataset: "treatment" | "clinical",
    clinicalEvent?: LabelAndValue[],
    clinicalIndication?: LabelAndValue[],
    clinicalEventCustom?: LabelAndValue[],
    treatmentVMP?: LabelAndValue[],
    treatmentCustom?: LabelAndValue[],
};


export type CriterionPcad = Criterion & CriterionPcadValues;

export type CriterionHesValues = {
    dataset?: "inpatient" | "outpatient";
    diagnosis?: LabelAndValue[];
    diagnosisType?: string[];
    procedures?: LabelAndValue[];
    treatments?: LabelAndValue[];
    hrgs?: LabelAndValue[];
    trusts?: LabelAndValue[];
    subICBLocations?: LabelAndValue[];
    gender?: string[];
    admissionMethod?: AdmissionMethod;
    fromAge?: number;
    toAge?: number;
    trackedCohort?: LabelAndValue[];
}

export type CriterionHes = Criterion & CriterionHesValues;

export interface Period {
    from: string;
    to: string;
    lookback: number | null;
    followup: number | null;
}

export interface SparkQuery {
    id: number;
    active: boolean | true;
    createdOn?: number;
    updatedOn?: number;
    requestId: string;
    queryType: string;
    name: string;
    request: string;
    response?: string
    status: string | null;
    submissionId: string | null;
}
